<div class="modal-header">
    <div class="modal-heading">{{ 'flipto.account.PhotoDetails' | translate }}</div>
</div>
<div class="edit-photo-container">
    <div class="edit-photo-content">
        <div class="image-wrapper">
            <img
                class="rotate"
                [src]="guest()?.poststay?.photo?.photoUrl"
                [style.transform]="'rotate(' + (guest()?.poststay?.photo?.degrees || 0) + 'deg)'"
                style="transition: transform 1s"
            />
        </div>
        <div class="edit-photo-actions">
            <div class="btn-rotate" (click)="changeRotateDegree()"></div>
        </div>
    </div>
</div>

<div class="ft-divider-h ft-divider-light"></div>

@if (identity.isFliptoStaff()) {
    <div class="edit-text-container">
        <div class="modal-panel modal-panel-input">
            <div class="ft-label">Caption</div>
            <textarea
                type="text"
                [value]="guest()?.poststay?.photo?.caption || ''"
                (input)="setCaption($any($event.target).value)"
            ></textarea>
        </div>
        @if ((isInvitee() && hasQuote()) || !isInvitee()) {
            <div class="modal-panel modal-panel-input">
                <div class="ft-label">Quote</div>
                <textarea
                    type="text"
                    [value]="guest()?.poststay?.quote?.notesPositive || ''"
                    (input)="setQuote($any($event.target).value)"
                ></textarea>
            </div>
        }
    </div>
}
